import type { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CalendarEvent } from './utils';

export const useStyles = makeStyles((theme) => ({
  calendarWrapper: {
    position: 'relative',
    height: `calc(100vh - ${theme.spacing(8)})`,
    paddingTop: theme.spacing(1),
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export const eventStyles = (event: CalendarEvent, theme: Theme) => ({
  style: {
    backgroundColor:
      event.resource.type === 'campaign'
        ? theme.palette.primary.main
        : 'transparent',
    color:
      event.resource.type === 'campaign'
        ? theme.palette.common.white
        : theme.palette.primary.main,
    border: event.resource.auto
      ? `2px solid ${theme.palette.primary.dark}`
      : `1px solid ${theme.palette.primary.main}`,
  },
});
